
export default {
  data() {
    return {
      xmlBaseUrl: 'https://files.transkribus.eu/Get?id=',
      jsonBaseUrl: 'https://files.transkribus.eu/iiif/2'
    }
  },
  methods: {
    getContentXMLSource(id) {
      return `${this.xmlBaseUrl}${id}`
    },
    getContentJSONSource(id) {
      return `${this.jsonBaseUrl}${id}`
    }
  }
}
